<mat-card appearance="outlined">
  <!-- Cabecera -->
  <mat-card-header>
    <div class="header-nombre-nuevo">
      <h2>Movimientos Expediente</h2>
 <app-button-new  (click)="openDialog({ accion: accionesDialog.Agregar, entidad: {idExpediente} })"></app-button-new>
    </div>
  </mat-card-header>

  <!-- Contenido de filtros -->
  <mat-card-content>
    <form [formGroup]="formFilter">
      <div class="row">
        <div class="col-sm-12 col-md-8 col-lg-6" *ngIf="!idExpediente">
          <app-buscar-expediente (eventEntity)="selectExpediente($event)"></app-buscar-expediente>
        </div>

        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Descripción</mat-label>
            <input matInput type="text"  formControlName="Descripcion" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango de Fechas</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate placeholder="Desde" [formControl]="formFilter.get('FechaDesde')">
              <input matEndDate placeholder="Hasta" [formControl]="formFilter.get('FechaHasta')">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>

        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spEstadosMovimientoExpediente" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Estados</mat-label>
            <mat-select multiple placeholder="Seleccione opcion" formControlName="IdsEstadoMovimientoExpediente">
              <mat-option [value]="estadoMovimientoExpediente.id" *ngFor="
                    let estadoMovimientoExpediente of estadosMovimientoExpediente;
                    let i = index;
                    trackBy: trackByItems
                  ">
                {{ estadoMovimientoExpediente.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-checkbox formControlName="EsConArchivo">
            ¿Contiene archivo?
          </mat-checkbox>
        </div>

        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-checkbox formControlName="EsConEscrito">
            ¿Contiene escrito?
          </mat-checkbox>
        </div>


        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango de Fechas de Alta</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate placeholder="FechaAltaDesde" [formControl]="formFilter.get('FechaAltaDesde')">
              <input matEndDate placeholder="FechaAltaHasta" [formControl]="formFilter.get('FechaAltaHasta')">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>

        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Titulo de archivo</mat-label>
            <input matInput type="text" maxlength="200" formControlName="TituloArchivo" />
          </mat-form-field>
        </div>
        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Contenido de escrito</mat-label>
            <input matInput type="text" maxlength="200" formControlName="ContenidoEscrito" />
          </mat-form-field>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-auto">
          <div style="display: flex; align-items: center; gap: 8px;">
            <app-button-filter-table (click)="aplicarFiltro()"></app-button-filter-table>
            <app-button-filter-table-clear (click)="limpiarFiltro()"></app-button-filter-table-clear>
          </div>

        </div>
        <div class="col-auto">
          <mat-slide-toggle (change)="filtrosAvanzados($event)" color="primary">
            Filtros Avanzados
          </mat-slide-toggle>
        </div>
      </div>
    </form>
  </mat-card-content>

  <mat-card-content>
    <mat-divider></mat-divider>
    <ngx-spinner [zIndex]="100" name="spListado" bdColor="rgba(255,255,255,0.8)" size="default"
      color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>

    <!-- Barra de acciones -->
    <!-- Inicio Contenedor acciones tabla -->
    <div class="contenedor-acciones-tablas">
      <div class="acciones-tabla">
        <!-- Boton de Acciones -->
        <!-- <app-button-action></app-button-action> -->
      </div>
      <mat-form-field appearance="outline" *ngIf="data" class="buscador-tabla">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label>Buscar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" #input />
      </mat-form-field>
    </div>
    <!-- Fin Contenedor acciones tabla -->

    <!-- Tabla De datos -->
    <div>

      <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" *ngIf="data" matSort matSortStart="asc">
        <ng-container matColumnDef="expediente">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Expediente</strong>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let item">
            <span>{{ item.expediente?.caratula | titlecase }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="descripcion">
          <mat-header-cell mat-header-cell *matHeaderCellDef
            mat-sort-header><strong>Descripción</strong></mat-header-cell>
          <mat-cell mat-cell *matCellDef="let item">
            <span>
              {{
              item.descripcion}}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estadoMovimientoExpediente">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Estado Movimiento</strong>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let item">
            <span> {{ item.estadoMovimientoExpediente?.descripcion}}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fecha">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Fecha</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.fecha | date:'short' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estados">
          <mat-header-cell mat-header-cell *matHeaderCellDef><strong>Estados</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let item">
            <mat-icon class="icon-hover" [matTooltip]="'Contiene escrito: '+ item.escrito?.titulo" *ngIf="item.escrito"
              >description</mat-icon>
            <mat-icon class="icon-hover" matTooltip="Contiene archivo" *ngIf="item.archivo">attach_file</mat-icon>
          </mat-cell>
        </ng-container>

        <!-- Accion Column -->
        <ng-container matColumnDef="accion">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            <strong>Acción</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let item" class="action-link">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Ver, entidad: {item} })"
                >
                <mat-icon>visibility</mat-icon>
                <span>Ver</span>
              </button>
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Modificar, entidad: {item} })"
                >
                <mat-icon>edit</mat-icon>
                <span>Editar</span>
              </button>
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Eliminar, entidad: {item} })"
              >
                <mat-icon>delete</mat-icon>
                <span>Eliminar</span>
              </button>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row matRipple *matRowDef="let row; columns: displayedColumns"></mat-row>
      </table>

      <app-sin-datos-para-mostrar [dataSource]="dataSource"></app-sin-datos-para-mostrar>

      <mat-paginator showFirstLastButtons class="paginator" *ngIf="data" [pageSize]="20"
        [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
      </mat-paginator>
    </div>
  </mat-card-content>
</mat-card>
